<template>
  <v-row no-gutters>
    <v-col cols="12" lg="8">
      <p class="text-h2 mb-12">
        {{ $t('STEPPER_PHANTOM_OFFER_TITLE') }}
      </p>
      <p>
        {{
          isSigned ? $t('STEPPER_PHANTOM_OFFER_TEXT_SIGNED') : $t('STEPPER_PHANTOM_OFFER_TEXT_SIGN')
        }}
      </p>
    </v-col>
    <SummaryCard>
      <template v-slot:save-and-reset-offer-buttons>
        <SaveAndResetOfferButtons @onSaveClicked="saveOffer" @onResetClicked="resetOffer" />
      </template>
    </SummaryCard>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'
import { OFFER_STATUS, VALIDATION_STATUS } from '@/helpers/constants'
import SummaryCard from '@/components/summary-card'
import SaveAndResetOfferButtons from '@/components/buttons/SaveAndResetOfferButtons'

export default {
  name: 'TypeFSignOff',
  components: { SummaryCard, SaveAndResetOfferButtons },
  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM]),
    isSigned() {
      return this[GET_OFFER_ITEM]('status') === OFFER_STATUS.SIGNED
    },
    validationStatus() {
      return this[GET_OFFER_ITEM]('validationStatus')
    },
    isSignatureForbidden() {
      return this.validationStatus !== VALIDATION_STATUS.APPROVED
    },
  },
  methods: {
    saveOffer() {
      this.$emit('onSaveClicked')
    },
    resetOffer() {
      this.$emit('onResetClicked')
    },
  },
  created() {
    this.$emit('onChangeIsContinueForbidden', this.isSignatureForbidden)
  },
  watch: {
    isSignatureForbidden() {
      this.$emit('onChangeIsContinueForbidden', this.isSignatureForbidden)
    },
  },
}
</script>
